/* React */
import React, { forwardRef } from "react";

/* React Redux */
import { Dispatch } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setCurrentCohort,
  deleteCustomCohort,
  upsertCustomCohort,
} from "src/redux/features/custom-cohorts/customCohortsSlice";

/* Ionic */
import {
  IonItemOptions,
  IonItemOption,
  IonIcon,
} from "@ionic/react";
import { save, create, trash } from "ionicons/icons";

/* Stylesheet */
import styles from "./ItemOptions.module.scss";

/* Interfaces */
import {
  CustomCohortsProps,
  Status,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface ItemOptionsProps {
  ref: React.ForwardedRef<HTMLIonItemSlidingElement>;
  item: CustomCohortsProps;
  dispatch: Dispatch;
}

const ItemOptions = forwardRef<
  HTMLIonItemSlidingElement,
  ItemOptionsProps
>(({ item, dispatch }, ref) => {
  const { id, status } = item;

  const segments = useSelector(
    (state: RootState) =>
      state.customCohorts.customCohort.data
  );

  const { name } = useSelector(
    (state: RootState) => state.customCohorts.customCohort
  );

  return (
    <IonItemOptions
      className={styles.item_options}
      side="end"
    >
      <IonItemOption
        className={`${styles.item_option} ${styles.edit}`}
        onClick={() => {
          if (status === Status.EDITING) {
            dispatch(
              upsertCustomCohort({
                ...item,
                name: name,
                data: segments,
              })
            );
            if (typeof ref !== "function" && ref?.current) {
              ref.current.close();
            }
          } else {
            dispatch(
              setCurrentCohort({
                id,
                status: Status.EDITING,
              })
            );
          }
        }}
      >
        <IonIcon
          className={styles.icon}
          icon={status === Status.EDITING ? save : create}
        />
      </IonItemOption>

      <IonItemOption
        className={`${styles.item_option} ${styles.delete}`}
        onClick={() => {
          dispatch(deleteCustomCohort(id));
        }}
      >
        <IonIcon className={styles.icon} icon={trash} />
      </IonItemOption>
    </IonItemOptions>
  );
});

ItemOptions.displayName = "ItemOptions";
export default ItemOptions;
